import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { AssessorResendAssessment } from 'containers/sections/assessors'
import { AjInfoTable } from 'components/sections/adventurous-journeys'
import { Button } from 'components/misc'
import {
  TasksAjParticipantEventsTableSingle,
  TasksAjEventsTableSingle
} from 'components/sections/tasks'
import { AjState } from 'containers/forms/aj-events'
import { modal } from 'redux/modules/app'
import { AWARD_TYPES, CONFIGURATION_KEYS, LEVELS, PROGRESS_STATES } from 'constants/enums'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'


@connect(null, {
  modal
})
class AjType extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
    changeAjParticipantEventState: PropTypes.func.isRequired,
    approveAjEventParticipant: PropTypes.func.isRequired,
    returnAjEventParticipant: PropTypes.func.isRequired,
    approveAjEvent: PropTypes.func.isRequired,
    rejectAjEvent: PropTypes.func.isRequired,
    changeAjParticipantEventGoal: PropTypes.func.isRequired,
    codeLists: PropTypes.object,
    isSimplifiedBronze: PropTypes.bool
  }
  static defaultProps = {
    data: {}
  }

  state = {
    id: null,
    actionId: null
  }

  key = uuid.v1()

  handleResendAjAssessment = (id, actionId) => {
    this.setState(
      {
        id,
        actionId
      },
      () => {
        this.props.modal(`modal-resend-aj-assessment-${this.key}`)
      }
    )
  }

  render() {
    const { data, codeLists, isSimplifiedBronze } = this.props

    return (
      <div>
        {data.map(item => {
          const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(item)

          return (
            <div key={item.id} className="base-margin--bottom">
              <AjState
                ajEventId={get(item, 'participantEvent.id')}
                ajEventState={get(item, 'participantEvent.state')}
                ajEventCategory={get(item, 'ajEventCategory.value')}
                approvalComponent={
                  <TasksAjEventsTableSingle
                    data={item}
                    modal={this.props.modal}
                    approveModal={this.props.approveAjEvent}
                    rejectModal={this.props.rejectAjEvent}
                    isAssessorManagementEnabled={isAssessorManagementEnabled}
                    codeLists={codeLists}
                    ajEventState={get(item, 'participantEvent.state')}
                    changeAjParticipantEventGoal={
                      this.props.changeAjParticipantEventGoal
                    }
                  />
                }
                signoffComponent={
                  <TasksAjParticipantEventsTableSingle
                    data={item}
                    modal={this.props.modal}
                    approveModal={this.props.approveAjEventParticipant}
                    returnModal={this.props.returnAjEventParticipant}
                    isAssessorManagementEnabled={isAssessorManagementEnabled}
                    codeLists={codeLists}
                  />
                }
                ajEventGeneral={
                  <AjInfoTable data={item} modal={this.props.modal} />
                }
                changeAjParticipantEventState={
                  this.props.changeAjParticipantEventState
                }
              />
              {get(item, 'participantEvent.state.value') ===
                PROGRESS_STATES.activityAssessment.id &&
                !get(item, 'participantEvent.isAssessmentPositive') && (
                  <div className="base-margin-bigger--bottom">
                    <Button
                      type="button"
                      secondary
                      intlKey="button.resend_assessment_request"
                      onClick={() =>
                        this.handleResendAjAssessment(
                          get(item, 'participantEvent.id'),
                          get(item, 'participantEvent.ajParticipantEvent')
                        )
                      }
                    >
                      Resend assessment request
                    </Button>
                  </div>
                )}
            </div>
          )
        })}

        {this.state.id && (
          <Modal id={`modal-resend-aj-assessment-${this.key}`} customActions>
            <AssessorResendAssessment
              id={this.state.id}
              actionId={get(data, 'participantEvent.ajParticipantEvent')}
              isParticipantEvent
            />
          </Modal>
        )}

        {data.length === 0 && !isSimplifiedBronze &&(
          <FormattedMessage id="label.no_data" defaultMessage="No data" />
        )}

        {data.length === 0 && isSimplifiedBronze && (
          <FormattedMessage id="label.no_data_simplified" defaultMessage="The Practice AJ is not a mandatory requirement for Bronze Participants. If you are completing a Practice Adventurous Journey, set this up in the Adventurous Journey menu as normal." />
        )}
      </div>
    )
  }
}

export default AjType
